import { useDeleteVenue } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { useRouter } from '@tanstack/react-router';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

type UseVenuesTableActionsReturnType = {
  handleDeleteVenue: (id: string) => void;
  handleEditVenue: (id: string) => void;
};

const TRANS_KEY = 'NOTIFICATIONS.DELETE_VENUE';

export const useVenuesTableActions = (): UseVenuesTableActionsReturnType => {
  const { t } = useTranslation('venues');
  const router = useRouter();
  const { showSuccess, showError } = useNotification();

  const onSuccess = () =>
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const { mutate: deleteVenue } = useDeleteVenue({
    mutation: {
      onSuccess,
      onError,
    },
  });

  const handleEditVenue = (id: string) => {
    router.navigate({
      to: '/venues/$id',
      params: { id },
    });
  };

  const handleDeleteVenue = (id: string) => {
    modals.openConfirmModal({
      title: t('DELETE_VENUE.CONFIRMATION_TITLE'),
      labels: {
        confirm: t('DELETE_VENUE.CONFIRM_BUTTON'),
        cancel: t('CANCEL_BUTTON', { ns: 'common' }),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm: () => deleteVenue({ id }),
    });
  };

  return {
    handleDeleteVenue,
    handleEditVenue,
  };
};
